export default "__VITE_ASSET__CsNmxQ$s__"